import React, { useState, useEffect } from 'react';
import '../styles/ProfileGeneration.css';

interface ProfileGenerationProps {
  onComplete: () => void;
}

const ProfileGeneration: React.FC<ProfileGenerationProps> = ({ onComplete }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [progress, setProgress] = useState(0);

  const steps = [
    { text: '正在读取您的就诊资料', priority: 'high' },
    { text: '分析健康指标数据', priority: 'high' },
    { text: '评估健康风险', priority: 'medium' },
    { text: '生成个性化建议', priority: 'medium' },
    { text: '完成健康档案创建', priority: 'low' }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(timer);
          setTimeout(onComplete, 1000);
          return 100;
        }
        return prev + 2;
      });
    }, 100);

    return () => clearInterval(timer);
  }, [onComplete]);

  useEffect(() => {
    const stepTimer = setInterval(() => {
      setCurrentStep(prev => {
        if (prev < steps.length - 1) {
          return prev + 1;
        }
        clearInterval(stepTimer);
        return prev;
      });
    }, 2000);

    return () => clearInterval(stepTimer);
  }, []);

  return (
    <div className="generation-container">
      <div className="generation-content">
        <div className="ai-avatar">
          <div className="avatar-circle">
            <span className="ai-icon">🤖</span>
          </div>
          <div className="thinking-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        
        <h2 className="generation-title">正在生成健康档案</h2>
        
        <div className="progress-container">
          <div className="progress-bar">
            <div 
              className="progress-fill" 
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <span className="progress-text">{Math.round(progress)}%</span>
        </div>
        
        <div className="steps-container-new">
          {steps.map((step, index) => (
            <div 
              key={index} 
              className={`step-item-new ${step.priority} ${
                index <= currentStep ? 'active' : ''
              } ${
                index < currentStep ? 'completed' : ''
              }`}
            >
              <div className="step-indicator"></div>
              <span className="step-text-new">{step.text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProfileGeneration;